"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Radio = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Radio.css") : void 0);
var _excluded = ["ariaLabel", "children", "checked", "className", "disabled", "labelClassName", "labelProps", "inputRef", "onChange", "size", "isControlled", "state", "readOnly"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-radio';
var Radio = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Radio, _props)) : _props;
  var ariaLabel = props.ariaLabel,
    children = props.children,
    checked = props.checked,
    className = props.className,
    disabled = props.disabled,
    labelClassName = props.labelClassName,
    labelProps = props.labelProps,
    inputRef = props.inputRef,
    onChange = props.onChange,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    isControlled = props.isControlled,
    state = props.state,
    readOnly = props.readOnly,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Radio.default);
  var classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, labelClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size === 'md'), "".concat(CSS_BLOCK, "--disabled"), disabled));
  var inputClasses = classnames(_constants.CSS_PREFIX, ["".concat(CSS_BLOCK, "__input")], (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "__input--")).call(_context2, state), state), "".concat(CSS_BLOCK, "__input--readonly"), !!readOnly), "".concat(CSS_BLOCK, "__input--disabled"), !!disabled), className);
  var input = /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, otherProps, {
    "aria-label": ariaLabel,
    "aria-disabled": disabled || readOnly,
    checked: isControlled ? !!checked : checked,
    className: inputClasses,
    disabled: disabled || readOnly,
    onChange: onChange,
    ref: inputRef,
    type: "radio"
  }));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _react.default.createElement("label", (0, _extends2.default)({}, labelProps, {
      className: classes,
      ref: ref
    }), input, children && /*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__label"))
    }, children))
  );
});
Radio.displayName = 'Radio';
Radio.propTypes = {
  /** Content to show as the label of the radio button.  */
  children: _propTypes.default.node,
  /** Localized text as aria-label for the `<input>` element.
   * This is required if `<Radio>` has no children.
   */
  ariaLabel: function ariaLabel(props) {
    var _context4;
    var children = props.children;
    for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      others[_key - 1] = arguments[_key];
    }
    if (!children) {
      var _PropTypes$string, _context3;
      return (_PropTypes$string = _propTypes.default.string).isRequired.apply(_PropTypes$string, (0, _concat.default)(_context3 = [props]).call(_context3, others));
    }
    return _propTypes.default.string.apply(_propTypes.default, (0, _concat.default)(_context4 = [props]).call(_context4, others));
  },
  /** @ignore */
  isControlled: _propTypes.default.bool,
  /** When `true`, radio button will appear "checked". */
  checked: _propTypes.default.bool,
  /** Custom classes to add to the `<input>` element. */
  className: _propTypes.default.string,
  /** When `true`, radio button will be marked as disabled. */
  disabled: _propTypes.default.bool,
  /** Attaches a ref to the `<input>` element. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Custom classes to add to the `<label>` element. */
  labelClassName: _propTypes.default.string,
  /** Other props to spread onto the `<label>` element. */
  labelProps: _propTypes.default.object,
  /** When `true`, radio button will be semantically disabled, but visually readonly. */
  readOnly: _propTypes.default.bool,
  /** @ignore - use **RadioGroup** size prop instead */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** @ignore - set by **RadioGroup** validationMessage prop. */
  state: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES),
  /** Sets the `value` attribute of the `<input>` element.
   * This value can be accessed from `event.target.value` in the `onChange` callback. */
  value: _propTypes.default.string,
  /** Callback function for onChange events.
   * This will override the `onChange` callback from the `RadioGroup` component
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onChange: _propTypes.default.func
};
var _default = exports.default = Radio;